import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  Stack,
} from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { StyledLabel } from "../../../common/components/InputLabel";

const ArchFormInput = ({ register, error, helperText }) => {
  return (
    <>
      <Grid item xs={3} sx={{ marginTop: 1 }}>
        <StyledLabel error={error} id="arch-form-label">
          Arch Form
        </StyledLabel>
        <FormHelperText variant="standard" error={error}>
          {helperText}
        </FormHelperText>
      </Grid>
      <Grid item xs={9}>
        <FormControl error={error}>
          <Box>
            <RadioGroup aria-labelledby="arch-form-label" name="archForm">
              <FormControlLabel
                value="Maintain"
                control={<Radio {...register} />}
                label="Maintain"
              />
              <FormControlLabel
                value="Round Out"
                control={<Radio {...register} />}
                label="Round Out"
              />
              <FormControlLabel
                value="Improve"
                control={<Radio {...register} />}
                label="Improve"
              />
              <FormControlLabel
                value="Constrict"
                control={<Radio {...register} />}
                label="Constrict"
              />
            </RadioGroup>
          </Box>
        </FormControl>
      </Grid>
    </>
  );
};

export default ArchFormInput;
